import {Box, Typography, styled} from '@mui/material';

const CompleteProfileCardContainer = styled(Box)(({theme}) => ({
	backgroundColor: theme.colors.light.primary['15Percent'],
	border: `1px solid ${theme.palette.divider}`,
	borderRadius: '12px',
	padding: '12px 16px',
	width: '100%',
}));

const StyledBox = styled(Box)({
	top: 0,
	left: 0,
	bottom: 0,
	right: 0,
	position: 'absolute',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

const StyledTypography = styled(Typography)({
	fontWeight: 600,
	lineHeight: 1.43,
	display: 'flex',
	alignItems: 'center',
});

const ProgressContainer = styled(Box)<{$size: number}>`
	position: relative;
	width: ${props => props.$size}px;
	height: ${props => props.$size}px;
	flex-shrink: 0;
`;

export {CompleteProfileCardContainer, StyledBox, StyledTypography, ProgressContainer};
